<template>
  <Dialog
    title="查看"
    :close-on-click-modal="false"
    :visible.sync="modal"
    class="question-modal"
  >
    <el-descriptions :column="1">
      <el-descriptions-item label="题型">
        <dict-tag type="theory_type" :value="questionDetail.questionType"
      /></el-descriptions-item>
      <el-descriptions-item label="题干">
        <div v-html="questionDetail.questionStem"></div
      ></el-descriptions-item>
      <el-descriptions-item
        label="选项"
        v-if="['1', '2', '3'].includes(String(questionDetail.questionType))"
      >
        <div v-for="(item, index) in questionDetail.list" :key="index">
          {{ item.answerFLag }}.{{ item.answerStem }}
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="答案">
        {{ questionDetail.questionAnswer }}
      </el-descriptions-item>
    </el-descriptions>
  </Dialog>
</template>
<script>
import { getQuestionBankDetail } from "@/api/questionBank/theory";
export default {
  data() {
    return {
      modal: false,
      questionDetail: {
        questionStem: null,
        questionType: null,
        questionAnswer: null,
        list: null
      }
    };
  },
  methods: {
    async getInfo(id) {
      const res = await getQuestionBankDetail(id);

      this.modal = true;
      const data = res.data || {};
      if ((!data.list || !data.list.length) && data.qaList) {
        data.list = data.qaList;
      }
      this.questionDetail = data;
    },
    async open(id) {
      this.modal = true;
      await this.getInfo(id);
    }
  }
};
</script>
<style lang="less" scoped>
.question-modal {
  /deep/ .el-descriptions-item__content {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/QuestionBank/theory/TheoryBankDetail.vue